import { useState } from "react";

const faqs = [
  {
    question: "Day Temizlik hangi bölgelerde hizmet veriyor?",
    answer: "Ana hizmet bölgemiz Sarıçam olmak üzere Çukurova, Seyhan, Yüreğir ve Adana genelinde profesyonel temizlik, yönetim ve ilaçlama hizmetleri sunuyoruz.",
  },
  {
    question: "Randevu nasıl oluşturulur?",
    answer: "Web sitemizdeki iletişim formunu doldurarak, telefon numaramızdan arayarak veya WhatsApp üzerinden yazarak randevu oluşturabilirsiniz. Size en kısa sürede dönüş yaparak uygun zaman planlaması yapıyoruz.",
  },
  {
    question: "Daire temizliği ne kadar sürer?",
    answer: "Daire temizliği süresi, mekanın büyüklüğüne ve temizlik ihtiyacına göre değişir. Genel olarak 2+1 bir daire 2-3 saat, 3+1 bir daire 3-4 saat sürebilir.",
  },
  {
    question: "İnşaat sonrası temizlikte neler yapılır?",
    answer: "İnşaat tozu temizliği, zemin temizliği, cam ve uygun yüzey temizliği, banyo ve mutfak alanlarının temizliği, kapı, pencere ve dolap dış yüzey temizliği yapılır. Alan kullanıma hazır şekilde teslim edilir.",
  },
  {
    question: "Apartman temizliği düzenli yapılabilir mi?",
    answer: "Evet, apartman temizliği haftalık, aylık veya ihtiyaca özel periyodik planlarla düzenli yapılabilir. Kullanım yoğunluğuna göre en uygun takvimi birlikte belirliyoruz.",
  },
  {
    question: "Koltuk yıkama hizmeti evde mi yapılır?",
    answer: "Koltuk yıkama hizmeti ev veya iş yerinde yerinde yapılır. Uygun ekipman ve temizlik maddeleri ile koltuklarınızı derinlemesine temizliyoruz.",
  },
  {
    question: "Halı yıkama süreci nasıl ilerler?",
    answer: "Halı toz alma, yıkama ve durulama süreci, leke odaklı temizlik, koku oluşumunu azaltmaya yönelik işlemler ve teslimat öncesi kontrol aşamalarından oluşur.",
  },
  {
    question: "İlaçlama hizmeti hangi alanlarda yapılır?",
    answer: "Ev, apartman, site ve iş yerleri olmak üzere tüm yaşam ve çalışma alanlarında profesyonel ilaçlama hizmeti sunuyoruz. Haşere ve böceklere karşı etkili uygulama yapılır.",
  },
  {
    question: "Ofis temizliği için periyodik hizmet var mı?",
    answer: "Evet, ofis ve iş yerleri için haftalık, haftada iki kez veya aylık düzenli periyodik temizlik planları oluşturuyoruz.",
  },
  {
    question: "Site yönetimi hizmeti neleri kapsar?",
    answer: "Ortak alan hizmetlerinin takibi, temizlik ve bakım süreçlerinin koordinasyonu, apartman ve site ihtiyaçlarının planlanması, sakinlerle iletişim sürecinin düzenlenmesi ve düzenli kontrol raporlaması yapılır.",
  },
  {
    question: "Fiyatlar nasıl belirlenir?",
    answer: "Fiyatlar hizmet türüne, alan büyüklüğüne, temizlik yoğunluğuna ve periyodiklik durumuna göre değişir. Detaylı bilgi almak için bizi arayabilir veya form doldurabilirsiniz.",
  },
  {
    question: "Aynı gün hizmet alınabilir mi?",
    answer: "Acil durumlar ve müsaitlik durumuna göre aynı gün hizmet almanız mümkün olabilir. Hızlı iletişim için telefon veya WhatsApp üzerinden bize ulaşabilirsiniz.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/80 px-3 py-1.5 rounded-full mb-3">
            SSS
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Sıkça sorulan sorular
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Day Temizlik hakkında merak edilenleri sizin için derledik. Başka sorularınız için bize ulaşabilirsiniz.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <i className={`ri-${openIndex === index ? "subtract" : "add"}-line w-5 h-5 flex items-center justify-center shrink-0 text-primary-500`}></i>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}